import { useAuth } from '@/core/contexts/AuthContext';
import { Redirect } from 'expo-router';
import React from 'react';
import { Platform } from 'react-native';

export interface BloomUniversalGuestGateProps {
  readonly children: React.ReactNode;
}

/**
 * Bloom Universal is web + logged-out only.
 * Native never mounts hub/space children (redirect to welcome).
 * Authenticated web users are sent to the app home.
 */
export function BloomUniversalGuestGate({
  children,
}: Readonly<BloomUniversalGuestGateProps>) {
  const { isAuthenticated, isLoading } = useAuth();

  // Defense: Universal UI + Contentful hooks must not run on iOS/Android.
  if (Platform.OS !== 'web') {
    return <Redirect href="/welcome" />;
  }

  if (isLoading) {
    return null;
  }

  if (isAuthenticated) {
    return <Redirect href="/(auth)/(home)" />;
  }

  return <>{children}</>;
}

export default BloomUniversalGuestGate;
